import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { TreeService } from '../../../../../@core/service/tree.service';
import { CompilationTypeData, DocConfig, SpoStatusData, TransportStatusData, UnitData } from '../../../../../@models/erp/compilationData';
import { SharedDataService } from '../../../../../@core/service/shared-data.service';
import { CompilationModel } from '../../../../../@models/erp/compilation';
import { DownloadConfig } from '../../document-printer/document-printer.component';
import { LineItemModel } from '../../../../../@models/erp/lineItem';
import { ApiService } from '../../../../../@core/service/api.service';
import { mongoId } from '../../../../../@core/common/global';
import { EContactType } from '../../../../../@models';
import { ContactUtil } from '../../../shared/doc-form-address-selector/doc-form-address-selector.component';

@Component({
  selector: 'ngx-cover-sheet',
  templateUrl: './cover-sheet.component.html',
  styleUrls: ['./cover-sheet.component.scss']
})
export class CoverSheetComponent implements OnChanges, OnInit, OnDestroy {

  @Input() print: boolean;
  @Input() compilation: CompilationModel;
  @Input() lineItemIdx: number = undefined;

  unitData = UnitData;
  transportStatusData = TransportStatusData;
  spoStatusData = SpoStatusData;
  docConfig = DocConfig;

  vieDispatchDate = null
  
  coverSheetSpos: { spos: any, sumQ: number } = { spos: [], sumQ: 0 };

  subscriptions = [];

  constructor(protected tree: TreeService, protected api: ApiService, protected data: SharedDataService, private cdRef: ChangeDetectorRef, private elRef: ElementRef) {
  }

  ngOnInit(): void {
    this.vieDispatchDate = this.tree.linkedOC?.vieDispatchDate || this.compilation.vieDispatchDate;
    this.subscriptions.push(this.tree.documentTreeLoadedEvent.subscribe(s => {
      this.vieDispatchDate = this.tree.linkedOC?.vieDispatchDate || this.compilation.vieDispatchDate;
    }))
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.compilation) {
      const associatedSpos = this.compilation.lineItems.reduce((a, c) => [...a, ...(c?.pfspo ?? [])], []);
      // console.log('===> ', associatedSpos);
      this.coverSheetSpos = {
        spos: associatedSpos,
        sumQ: associatedSpos.reduce((a, c) => a + (+c.quantity), 0),
      }
      // this.vieDispatchDate = this.compilation.vieDispatchDate;
      // if (this.compilation.type !== CompilationTypeData.get('OC').id) {
      //   let doc = this.compilation;
      //   console.log('doc 1', doc.parent);
      //   do {
      //     doc = await this.api.loadCompilationByCode(doc.parent);
      //   } while (doc && this.compilation.type !== CompilationTypeData.get('OC').id)
      //   console.log('doc 2', doc.parent);
      //   this.vieDispatchDate = doc.vieDispatchDate
      // }
      // this.vieDispatchDate = this.tree.linkedOC?.vieDispatchDate;

    }
  }

  isMixedPallet() {
    return this.compilation.packingConditions?.find(f => f.palletType === 'P9');
  }

  getPackingSpecs(item: LineItemModel) {
    // console.log(item, item.finishedProduct, item.finishedProduct?.packing);
    return this.data.getOptionName(this.data.packingOptions, item.finishedProduct?.packing);
  }

  getDeliveryAddress() {
    // return (new ContactUtil(this.data)).getAddressFromBusiness(
    //   mongoId(this.compilation.deliveryRecipient), 
    //   DocConfig.get('palletLabelAddress').fields, 
    //   EContactType.General,
    //   false
    // )
    const lines = this.compilation?.deliveryAddress?.split(/\n/);
    if (!lines?.length) return '';
    const lastLine = lines.splice(lines.length-1,1);
    lines[lines.length-1] += ', ' + lastLine;
    return lines.join('\n');
  }
}
